export default __webpack_public_path__ + "static/media/Krud-Kutter-Banner.24d620c6.jpg";